import { Component, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';
import { CookieService } from 'src/app/Services/Global/Cookies/cookie.service';
import { GeneralLibraryCDMS, typeSystemLibraryCDMS } from 'src/app/types/General/Library.type';
import { LibraryMasterService } from 'src/app/Services/Libraries/Library-Master/library-master.service';
import { firstValueFrom } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { GeneralRoleCDMS, typeSystemRoleCDMS } from 'src/app/types/General/RoleCDMS.type';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss', '../../Styles/GlobalStyles.css'],
    standalone: false
})
export class DashboardComponent implements OnInit {

  //+================== VARIABLE LENGUAJE ==================+\\
  public Selected: string = '';

  //+================== VARIABLE ROLES GENERAL ==================+\\
  public RolesGeneral: typeSystemRoleCDMS = GeneralRoleCDMS;

  //+================== VARIABLE LIBRARY GENERAL ==================+\\
  public LibraryGeneral: typeSystemLibraryCDMS = GeneralLibraryCDMS;


  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  public UserService = inject(UserDataService);
  private CookieService = inject(CookieService);
  private MasterLibraryService = inject(LibraryMasterService);
  private router = inject(Router);

  public activeLibraries: any[] = [];
  public isLoadingLogout: boolean = false;



  ngOnInit(): void {
    this.LoadActiveLibraries();

    // Refresca librerías visibles cuando se navega entre vistas para reflejar cambios de permisos en caliente.
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.LoadActiveLibraries();
        this.CloseAllMenus(); // Cerrar menús al navegar (ideal para móviles)
        
        // Resetea el scroll del contenedor principal al tope tras navegar
        setTimeout(() => {
          const container = document.querySelector('.container-global');
          if (container) {
            container.scrollTop = 0;
          }
        }, 50);
      });
  }

  async LoadActiveLibraries() {
    try {
      const res: Response_FIN = await firstValueFrom(this.MasterLibraryService.Get_My_Active_Libraries());
      if (res.success) {
        // Filtrar librerías que ya existen como estáticas (Processes/FIN y CCP)
        this.activeLibraries = res.operation.filter((lib: any) => 
          lib.Slug.toLowerCase() !== 'processes' && 
          lib.Slug.toLowerCase() !== 'fin' && 
          lib.Slug.toLowerCase() !== 'ccp' &&
          lib.Slug.toLowerCase() !== 'hoe'
        );
      }
    } catch (e) {
      console.error('Error loading active libraries', e);
    }
  }

  public CanAccessFormModule(): boolean {
    return this.UserService.SharingDataUser.value.Role.some(
      (role: string) => role === this.RolesGeneral.FormTemplatesAdmin
    );
  }

  public CanAccessFormDashboard(): boolean {
    return this.UserService.SharingDataUser.value.Role.some(
      (role: string) => role === this.RolesGeneral.FormTemplatesAdmin
    );
  }

  public CanSeeReportsMenu(): boolean {
    if (this.UserService.IsSuperAdministrator()) {
      return true;
    }

    return this.UserService.SharingDataUser.value.Role.some((role: string) => {
      const normalized = String(role || '').toUpperCase();
      return normalized.startsWith('REPORTS') || normalized.startsWith('ADMINISTRATOR');
    });
  }

  public CanSeeRecycleMenu(): boolean {
    return this.UserService.CanSeeRecycleBin();
  }

  public CanSeeAdministratorMenu(): boolean {
    return this.UserService.UserHasAnyAdministratorRole();
  }

  public IsTasksSectionActive(): boolean {
    const url = String(this.router.url || '').toLowerCase();

    return url.includes('/dashboard/general/seealltaskcdms')
      || url.includes('/dashboard/fin/seealltaskslibfin')
      || url.includes('/dashboard/ccp/seealltaskslibccp')
      || url.includes('/dashboard/lib/hoe/seealltaskslibccp')
      || url.includes('/dashboard/fin/checktaskass/')
      || url.includes('/dashboard/ccp/checktaskass/')
      || url.includes('/dashboard/lib/hoe/checktaskass/');
  }

  public IsProcessesSectionActive(): boolean {
    const url = String(this.router.url || '').toLowerCase();
    const isProcessesArea = url.startsWith('/dashboard/fin');
    return isProcessesArea && !this.IsTasksSectionActive();
  }


  public isSidebarOpen: boolean = false;
  public isUserMenuOpen: boolean = false;

  ActiveSideBar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  public ToggleMenuUser(): void {
    this.isUserMenuOpen = !this.isUserMenuOpen;
  }

  public CloseAllMenus(): void {
    this.isUserMenuOpen = false;
    
    // Solo cerrar el sidebar automáticamente en móviles (< 768px) al navegar
    if (this.isSidebarOpen && window.innerWidth <= 768) {
      this.ActiveSideBar();
    }

  }


  public NameUser(): string {
    const Name_User: string = localStorage.getItem('Name_User') || "";

    return Name_User.length > 29 ? Name_User.slice(0, 30) + '...' : Name_User;
  }

  public CloseSession(): void {



    Swal.fire({
      title: '¿Desea cerrar la sesión?',
      text: `La sesión se cerrará completamente`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡Sí, cerrar!',
      cancelButtonText: 'No, cancelar',
    }).then(async (result) => {

      if (result.isConfirmed) {

        try {
          this.isLoadingLogout = true;
          
          setTimeout(() => {
            this.CookieService.deleteCookie('Token_COMPAS');
            this.CookieService.deleteCookie('Data_User_COMPAS');
            localStorage.clear();
            window.location.href = '/LoginCDMS/Home';
          }, 1000);


        } catch (e) {
          this.isLoadingLogout = true;

          setTimeout(() => {
            this.CookieService.deleteCookie('Token_COMPAS');
            this.CookieService.deleteCookie('Data_User_COMPAS');
            localStorage.clear();
            window.location.href = '/LoginCDMS/Home';
          }, 3000);
        }

      }
    })

  }



}
